<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AElroD/images/cover.jpg?1684229399429" alt="This image is the cover for the book Battle of Bennington: Soldiers & Civilians, Military"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Battle of Bennington: Soldiers & Civilians, Military
      </h1>
      <p class="bookDescription body article font2">
        <p><b>On August 16, 1777, a motley militia won a resounding victory near Bennington, Vermont, against combined German, British and Loyalist forces.</b></p><br/><p>This laid the foundation for the American victory at Saratoga two months later. Historian Michael P. Gabriel has collected over fifty firsthand accounts from the people who experienced this engagement, including veterans from both sides and civilians--women and children who witnessed the horrors of the battle. Gabriel also details a virtually unknown skirmish between Americans and Loyalists. These accounts, along with Gabriel's overviews of the battle, bring to life the terror, fear and uncertainty that caused thousands to see the British army as loved ones departed to fight for the fledgling United States.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael P. Gabriel, Tyler Resch
      </h2>
      
      <p class="authorDescription body article">Michael P. Gabriel, a professor of history at Kutztown University, grew up in Bradford, Pennsylvania. He earned his BS at Clarion University, his MA at St. Bonaventure and his PhD at Penn State. He is a member of the Pennsylvania Historical Association, the Society of Military History, the Johannes Schwalm Historical Association and the Kutztown Area Historical Society. His other works include authoring Major General Richard Montgomery: The Making of an American Hero (2002) and co-editing Quebec During the American Invasion, 1775-1776: The Journal of Francois Baby, Gabriel Taschereau, and Jenkin Williams (2005). Gabriel has also published numerous reviews and essays and has contributed entries to a variety of reference works. He and his wife, Sandy, live near Kutztown with their daughter, Katie.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09bcc598